import { sizes } from '@lmc/common/constants'
import { isBrowser, isTablet } from 'react-device-detect'

export const styles = {
  cancelButton: {
    marginRight: 10
  },
  divider: {
    display: 'flex',
    height: 2
  },
  footer: {
    border: 'none',
    display: 'flex',
    justifyContent: 'flex-end',
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw'
  },
  headerContainer: {
    paddingTop: 24
  },
  wrapper: {
    paddingBottom: 80,
    margin: '0 auto',
    maxWidth: sizes.childScreen
  },
  needItem: { marginLeft: 15, paddingTop: 15 },
  inputSelect: { maxWidth: 420 },
  formInputSelectWrapper: { marginBottom: 0 }
}

export default styles
